import { render, staticRenderFns } from "./BoardSelection.vue?vue&type=template&id=26015188&"
import script from "./BoardSelection.vue?vue&type=script&lang=ts&"
export * from "./BoardSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26015188')) {
      api.createRecord('26015188', component.options)
    } else {
      api.reload('26015188', component.options)
    }
    module.hot.accept("./BoardSelection.vue?vue&type=template&id=26015188&", function () {
      api.rerender('26015188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/BoardSelection.vue"
export default component.exports